import { z as zod } from "zod";
import { ZALO_LINK_MESSAGE, ZALO_LINK_REGEX } from "@onair/ui/event/constants";

export const SocialCommunitiesSchema = zod.object({
	socialCommunityType: zod.string().optional(),
	socialCommunityName: zod
		.string()
		.max(40, { message: "Vui lòng nhập tối đa 40 ký tự" })
		.optional()
		.or(zod.literal("")),
	socialCommunityLink: zod
		.string()
		.url({
			message: "Vui lòng nhập đường link hợp lệ",
		})
		.regex(ZALO_LINK_REGEX, {
			message: ZALO_LINK_MESSAGE,
		})
		.optional()
		.or(zod.literal("")),
});
